import React from 'react';
import { 
  BaseEdge, 
  EdgeLabelRenderer, 
  getStraightPath,
  MarkerType 
} from 'reactflow';

const DependencyEdge = ({ 
  id, 
  sourceX, 
  sourceY, 
  targetX, 
  targetY,
  label,
  data,
  markerEnd,
  style
}) => {
  const [edgePath, labelX, labelY] = getStraightPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
  });

  const handleClick = (event) => {
    event.stopPropagation();
    
    if (data?.onEdgeClick) {
      data.onEdgeClick({
        fromMachineId: data.fromMachineId,
        fromMachineName: data.fromMachineName,
        toMachineId: data.toMachineId,
        toMachineName: data.toMachineName,
        dependencyCount: data.dependencyCount
      });
    }
  };

  return (
    <>
      <BaseEdge 
        id={id} 
        path={edgePath} 
        markerEnd={markerEnd}
        style={{
          ...style,
          cursor: 'pointer'
        }}
      />
      <EdgeLabelRenderer>
        <div
          style={{
            position: 'absolute',
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            fontSize: 12,
            fontWeight: 600,
            pointerEvents: 'all',
            cursor: 'pointer',
            background: '#ff6b6b',
            color: 'white',
            padding: '4px 8px',
            borderRadius: '12px',
            boxShadow: '0 2px 8px rgba(255, 107, 107, 0.3)',
            transition: 'all 0.2s ease',
          }}
          className="dependency-edge-label"
          onClick={handleClick}
          onMouseEnter={(e) => {
            e.target.style.background = '#ff5252';
            e.target.style.transform = `translate(-50%, -50%) translate(${labelX}px,${labelY}px) scale(1.1)`;
          }}
          onMouseLeave={(e) => {
            e.target.style.background = '#ff6b6b';
            e.target.style.transform = `translate(-50%, -50%) translate(${labelX}px,${labelY}px) scale(1)`;
          }}
        >
          {label || `${data?.dependencyCount || 0} jobs`}
        </div>
      </EdgeLabelRenderer>
    </>
  );
};

export default DependencyEdge;